import Typography from '../../Atoms/Typography';
import fileIcon from '../../../assets/images/Folder/file.svg';
import downloadfileIcon from '../../../assets/images/Folder/download.svg';
import openfileIcon from '../../../assets/images/Folder/open.svg';
import ReactTooltip from 'react-tooltip';
import isEnterOrSpacePressed from 'utils/isEnterOrSpacePressed';

import './fileName.css';

function FileName({ folder, downloadArtefactLink, index }) {
  return (
    <div className="ltw-flex ltw-items-center ltw-justify-between artefact-file-row">
      <ReactTooltip id={`artefact-modal-1-${index}`} html={true} />
      <ReactTooltip id={`artefact-modal-${index}`} html={true} />
      <div className="ltw-flex ltw-items-center ltw-gap-8px ltw-p-5px">
        <img src={fileIcon} width="16" height="16" alt="folder" />
        <Typography
          extraClasses="ltw-break-all artifact-file-name"
          variant="h2"
          fontType="ltw-font-normal"
        >
          {folder.name}
        </Typography>
      </div>
      <div className="ltw-flex ltw-items-center ltw-gap-10px artefact-hover-action ltw-mr-4px ltw-flex-shrink-0">
        <div
          onClick={() => downloadArtefactLink(folder, 'download')}
          onKeyDown={(e) => {
            isEnterOrSpacePressed(e) &&
              downloadArtefactLink(folder, 'download');
          }}
          role="button"
          tabIndex="0"
          data-tip="Download"
          data-for={`artefact-modal-1-${index}`}
          className="artifact-action-btn"
        >
          <img src={downloadfileIcon} width="13" height="13" alt="download" />
        </div>
        <div
          onClick={() => downloadArtefactLink(folder, 'open')}
          onKeyDown={(e) => {
            isEnterOrSpacePressed(e) && downloadArtefactLink(folder, 'open');
          }}
          role="button"
          tabIndex="0"
          data-tip="Open"
          data-for={`artefact-modal-${index}`}
          className="artifact-action-btn"
        >
          <img src={openfileIcon} width="13" height="13" alt="open" />
        </div>
      </div>
    </div>
  );
}
export default FileName;
